/*jshint esversion: 9 */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import store from "../../../components/stores/Store";

import { deleteDeveloper } from "../../../db/DeveloperRequestHandler";
import { getIfFuncAuthorized } from "../../../utils/CheckSomething";


const styles = {
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
  tableContainer: {
    maxHeight: "450px", // todo
    maxWidth: "100%", // todo
  },
  table: {},
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
};
// TableOfDeveloperManagement
class TableOfDeveloperManagementInner extends Component {
  constructor() {
    super();
    store.setOrderByOfTableConfig("createdate");
    store.setOrderOfTableConfig("desc");
    this.state = {
      page: 0,
      rowsPerPage: 10,
      orderBy: "uid",
      order: "asc",
      deleteLineDialogOpen: false,
      toDeleteId: '',
    };
    this.sampleMehtod = this.sampleMehtod.bind(this);
    this.createData = this.createData.bind(this);
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);

    this.createSortHandler = this.createSortHandler.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
    this.closeDeleteLineDialog = this.closeDeleteLineDialog.bind(this);
    this.openDeleteLineDialog  = this.openDeleteLineDialog.bind(this);
  }

  async componentDidMount() { }
  componentWillUnmount() { }

  sampleMehtod(e) {
    console.log(e);
  }

  createData(uid, name) {
    return { uid, name };
  }
  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -1 * this.descendingComparator(a, b, orderBy);
  }

  handleOpen(e, num) {
    this.setState({
      openState: {
        ...this.state.openState,
        [num]: !this.state.openState[num],
      },
    });
  }

  handleRequestSort(event, property) {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    console.log(`----- handleRequestSort-event: `, event);
    console.log(`----- handleRequestSort-property: `, property);
    this.setState({ order: isAsc ? "desc" : "asc" });
    this.setState({ orderBy: property });
  }

  handleChangePage(event, newPage) {
    console.log(`----- handleChangePage-newPage: `, newPage);
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage(event) {
    console.log(`----- handleChangeRowsPerPage-event: `, event);
    this.setState({ rowsPerPage: parseInt(event.target.value, 10) });
    this.setState({ page: 0 });
  }

  createSortHandler(event, property) {
    if (property === "action") return;
    console.log(`----- createSortHandler-event: `, event);
    console.log(`----- createSortHandler-property: `, property);
    this.handleRequestSort(event, property);
  }

  closeDeleteLineDialog() {
    this.setState({
      toDeleteId: '',
      deleteLineDialogOpen: false,
    });
  }

  openDeleteLineDialog(e, id) {
    this.setState({
      toDeleteId: id,
      deleteLineDialogOpen: true,
    });
  }

  async deleteLine() {
    const id = this.state.toDeleteId;
    this.closeDeleteLineDialog();
    console.log(`----- send req of deleteLine`);
    const rst = await deleteDeveloper({ ID: id });
    console.log(`----- rst of 删除房产商: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "删除成功");
      this.setState({ addDialogOpen: false });
      store.search();
      return true;
    }
  }

  render() {
    const { classes } = this.props;
    const headCells = [
      // { id: 'uid',  align: 'center',  disablePadding: true,   label: 'ID' },
      {
        id: "name",
        align: "center",
        disablePadding: false,
        label: "开发商名称",
      },
      { id: "action", align: "center", disablePadding: false, label: "操作" },
    ];

    const emptyRows =
      this.state.rowsPerPage -
      Math.min(
        this.state.rowsPerPage,
        store.table.length - this.state.page * this.state.rowsPerPage
      );

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
              id="TableOfDeveloper"
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      padding={headCell.disablePadding ? "none" : "normal"}
                      sortDirection={
                        this.state.orderBy === headCell.id
                          ? this.state.order
                          : false
                      }
                    >
                      <TableSortLabel hideSortIcon>
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {this.stableSort(
                  store.table,
                  this.getComparator(this.state.order, this.state.orderBy)
                )
                  .slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                  )
                  .map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={row.id} id={row.id}>
                        <TableCell align="center">{row.name}</TableCell>
                        <TableCell align="center" style={{ width: "50%" }}>
                          <ButtonGroup
                            variant="contained"
                            aria-label="contained primary button group"
                          >
                            {getIfFuncAuthorized("房票管理-开发商管理-删除")
                              && (
                                <Button
                                  color="secondary"
                                  onClick={(e) => this.openDeleteLineDialog(e, row.ID)}
                                  style={{ width: '200px' }}
                                >
                                  删除
                                </Button>
                              )}
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 33 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 40]}
            component="div"
            count={store.table.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>

        <Dialog
          open={this.state.deleteLineDialogOpen}
          onClose={this.closeDeleteLineDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{width: '400px'}}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.deleteLine} color="secondary">
              确认删除
            </Button>
            <Button onClick={this.closeDeleteLineDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableOfDeveloperManagement = observer(TableOfDeveloperManagementInner);

TableOfDeveloperManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfDeveloperManagement);
